document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.tab-content');

  tabButtons.forEach(btn => {
    btn.addEventListener('click', function (event) {      

      destroyAllFlickityInstances()
      const clickedElement = event.target.closest('.tab-btn');
      console.log('sdasd',clickedElement)
      const tab = clickedElement.getAttribute('data-tab');

      

      tabButtons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      tabContents.forEach(content => {
        content.classList.remove('active');
      });

      

      document.querySelector('.tab-' + tab).classList.add('active');

      setTimeout(function(){ 
        initFlickity('.tab-' + tab + ' .carousel');
      }, 100);
      
    });
  });

   });

function initFlickity(selector) {

  const sliders = document.querySelectorAll(selector);
  console.log('dsad',selector)
            sliders.forEach((slider, index) => {
                // Check if it's already initialized to prevent errors
                let flkty = Flickity.data(slider);
                if (!flkty) {
                    new Flickity(slider, {"freeScroll": true , "wrapAround":true});                    
                }
                // else{
                //      flkty.destroy();
                // }
            })
}

 function destroyAllFlickityInstances() {
            // 1. Select all slider elements with the given class name.
            const slidersToDestroy = document.querySelectorAll('.carousel');

            // 2. Loop through each element found.
            slidersToDestroy.forEach((sliderElement, index) => {
                // 3. Get the Flickity instance for the current element.
                // Flickity.data() is the official way to get an instance from a DOM element.
                const flkty = Flickity.data(sliderElement);

                // 4. Check if a Flickity instance exists before trying to destroy it.
                if (flkty) {
                    flkty.destroy();
                } else {
                    console.log(`No Flickity instance found on slider ${index + 1}.`);
                }
            });
        }

  // Optional: Auto slide
//   const sliders = document.querySelectorAll('.slider');
//   sliders.forEach(slider => {
//     let scrollAmount = 0;
//     setInterval(() => {
//       slider.scrollBy({ left: 250, behavior: 'smooth' });
//       scrollAmount += 250;
//       if (scrollAmount >= slider.scrollWidth - slider.clientWidth) {
//         slider.scrollTo({ left: 0, behavior: 'smooth' });
//         scrollAmount = 0;
//       }
//     }, 3000);
//   });
// });
